import {Flag} from 'platform/components';
import {Box, Heading, HStack, VStack} from 'platform/foundation';

import {isEmpty, isNotNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {buildSortableItemId} from '@dms/features/dnd';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {IMAGE_SIZE} from '../../../constants/imageSize';
import {RenderAlbumImage} from '../types/RenderAlbumImage';
import {UnifiedAlbumImage} from '../types/UnifiedAlbumImage';

// A financing placeholder has no file; its tile is never dragged, but a sortable id needs a URL.
const PROMO_TILE_FALLBACK_DND_URL = 'promo-tile';

interface PromoPhotoStripProps extends RequiredTestIdProps {
  saleVehicleAlbumId: string;
  images: UnifiedAlbumImage[];
  renderAlbumImage: RenderAlbumImage;
}

/**
 * Promo Photos with the advertisement position each one takes. They are not Sales Album photos,
 * so the Photo Guide view keeps them out of the slots and does not let them be dragged.
 */
export function PromoPhotoStrip(props: PromoPhotoStripProps) {
  if (isEmpty(props.images)) {
    return null;
  }

  return (
    <VStack spacing={2}>
      <Heading size={5}>{i18n.t('entity.salesCampaign.labels.promoPhotos')}</Heading>
      <HStack spacing={3} wrap>
        {props.images.map((image, index) => (
          <Box key={image.id} width={IMAGE_SIZE.width}>
            {props.renderAlbumImage(image, index, {
              list: props.images,
              dndId: buildSortableItemId(
                image.id,
                `${props.saleVehicleAlbumId}:promo`,
                isNilOrEmpty(image.url) ? PROMO_TILE_FALLBACK_DND_URL : image.url,
                index
              ),
              testId: `promo-[${index}]`,
              isDisabledDndDrag: true,
              isDisabledDndDrop: true,
              caption: isNotNil(image.position) ? (
                <Flag
                  label={i18n.t('entity.photoGuide.labels.promoPosition', {
                    position: image.position,
                  })}
                  colorScheme="neutral"
                  isSubtle
                  size="small"
                  data-testid={suffixTestId(`promo-[${index}]-position`, props)}
                />
              ) : undefined,
            })}
          </Box>
        ))}
      </HStack>
    </VStack>
  );
}
